import { AnimatePresence, m as motion } from 'framer-motion';
import { CaretDown } from '@phosphor-icons/react';
import { Inline, vars } from '@etg/wings';
import { useState } from 'react';
import { useTranslation } from '@eti/providers';
import { DangerousHtmlContent } from '@eti/components';
import { css, cx, getTextStyles, mediaQueries } from '@eti/styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const linkColor = vars.colors.links.default;
const wrapperStyles = css`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
`;
const contentText = css`
  margin-top: 16px;
  padding-inline: 24px 16px;

  > *:not(:last-child) {
    margin-bottom: 16px;
  }

  ul {
    li {
      padding-inline-start: 12px;

      &:not(:last-child) {
        display: flex;
        margin-bottom: 8px;
      }
    }
    &::before {
      display: flex;
      left: 0;
      margin-right: 8px;
      position: absolute;
    }
  }
`;
const buttonStyles = css`
  background: none;
  border: none;
  color: ${linkColor};
  cursor: pointer;
  text-decoration: underline;
  z-index: 1;
`;
const fontSize = css`
  @media ${mediaQueries.medium.up} {
    font-size: 0.875rem;
  }
`;
const ReadMore = _ref => {
  let {
    content,
    productId
  } = _ref;
  const {
    t
  } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  return /*#__PURE__*/_jsxs("div", {
    className: wrapperStyles,
    "data-testid": `read-more-${productId}`,
    children: [/*#__PURE__*/_jsx("button", {
      "aria-controls": `mutuallyExclusiveReadMoreContent-${productId}`,
      "aria-expanded": isOpen,
      className: buttonStyles,
      "data-testid": `mutuallyExclusiveReadMoreContent-button-${productId}`,
      onClick: () => setIsOpen(!isOpen),
      type: "button",
      children: /*#__PURE__*/_jsxs(Inline, {
        alignY: "center",
        "data-testid": `read-more-label-${productId}`,
        spacing: 8,
        children: [isOpen ? t('Products.ReadLess.Link.Label') : t('Products.ReadMore.Link.Label'), /*#__PURE__*/_jsx(motion.div, {
          animate: {
            rotateX: isOpen ? 180 : 0,
            display: 'flex'
          },
          children: /*#__PURE__*/_jsx(CaretDown, {
            color: linkColor,
            size: 18,
            weight: "light"
          })
        })]
      })
    }), /*#__PURE__*/_jsx(AnimatePresence, {
      children: isOpen && /*#__PURE__*/_jsx(motion.div, {
        animate: {
          height: 'auto'
        },
        exit: {
          height: 0
        },
        id: `mutuallyExclusiveReadMoreContent-${productId}`,
        initial: {
          height: 0,
          overflow: 'hidden'
        },
        transition: {
          duration: 0.3
        },
        children: /*#__PURE__*/_jsx(DangerousHtmlContent, {
          className: cx(getTextStyles(), contentText, fontSize),
          content: content
        })
      })
    })]
  });
};
export default ReadMore;